import { render } from "./NoteConfirmCard.vue?vue&type=template&id=4d4d80fa&scoped=true"
import script from "./NoteConfirmCard.vue?vue&type=script&lang=js"
export * from "./NoteConfirmCard.vue?vue&type=script&lang=js"

import "./NoteConfirmCard.vue?vue&type=style&index=0&id=4d4d80fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4d80fa"]])

export default __exports__